import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { TransportOrderIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ShipmentTransportOrderEndpoint } from '../../constants';
import { ShipmentTransportOrderNotificationsModel } from '../../models/shipment-transport-order-notifications.model';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderNotificationsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentTransportOrderNotifications(
    transportOrderIdView: TransportOrderIdView,
  ): Observable<ShipmentTransportOrderNotificationsModel[]> {
    return this.http
      .withLoading()
      .get<ShipmentTransportOrderNotificationsModel[]>(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.Notifications
        }?${getQueryStringFromObject(transportOrderIdView)}`,
      );
  }
}
